module Hereabout.UI.Bulma.Classes where

import Prelude

import Halogen as H
import Halogen.HTML.Properties as HP

block ∷ H.ClassName
block = H.ClassName "block"

box ∷ H.ClassName
box = H.ClassName "box"

button ∷ H.ClassName
button = H.ClassName "button"

card ∷ H.ClassName
card = H.ClassName "card"

cardContent ∷ H.ClassName
cardContent = H.ClassName "card-content"

cardFooter ∷ H.ClassName
cardFooter = H.ClassName "card-footer"

cardFooterItem ∷ H.ClassName
cardFooterItem = H.ClassName "card-footer-item"

cardImage ∷ H.ClassName
cardImage = H.ClassName "card-image"

cell ∷ H.ClassName
cell = H.ClassName "cell"

column ∷ H.ClassName
column = H.ClassName "column"

columns ∷ H.ClassName
columns = H.ClassName "columns"

content ∷ H.ClassName
content = H.ClassName "content"

control ∷ H.ClassName
control = H.ClassName "control"

delete ∷ H.ClassName
delete = H.ClassName "delete"


fas ∷ H.ClassName
fas = H.ClassName "fas"

field ∷ H.ClassName
field = H.ClassName "field"

fixedGrid ∷ H.ClassName
fixedGrid = H.ClassName "fixed-grid"

grid ∷ H.ClassName
grid = H.ClassName "grid"

hasAddons ∷ H.ClassName
hasAddons = H.ClassName "has-addons"

hasBackgroundPrimary ∷ H.ClassName
hasBackgroundPrimary = H.ClassName "has-background-primary"

has1ColsMobile ∷ H.ClassName
has1ColsMobile = H.ClassName "has-1-cols-mobile"

has2ColsTablet ∷ H.ClassName
has2ColsTablet = H.ClassName "has-2-cols-tablet"

has3Cols ∷ H.ClassName
has3Cols = H.ClassName "has-3-cols"

has3ColsDesktop ∷ H.ClassName
has3ColsDesktop = H.ClassName "has-3-cols-desktop"

hasDropdown ∷ H.ClassName
hasDropdown = H.ClassName "has-dropdown"

hasTextCentred ∷ H.ClassName
hasTextCentred = H.ClassName "has-text-centered"

hasTextBlack ∷ H.ClassName
hasTextBlack = H.ClassName "has-text-black"

hasTextWarning ∷ H.ClassName
hasTextWarning = H.ClassName "has-text-warning"

hero ∷ H.ClassName
hero = H.ClassName "hero"

heroBody ∷ H.ClassName
heroBody = H.ClassName "hero-body"

icon ∷ H.ClassName
icon = H.ClassName "icon"

iconText ∷ H.ClassName
iconText = H.ClassName "icon-text"

image ∷ H.ClassName
image = H.ClassName "image"

is16By9 ∷ H.ClassName
is16By9 = H.ClassName "is-16by9"

is32x32 ∷ H.ClassName
is32x32 = H.ClassName "is-32x32"

is64x64 ∷ H.ClassName
is64x64 = H.ClassName "is-64x64"

is128x128 ∷ H.ClassName
is128x128 = H.ClassName "is-128x128"

isActive ∷ H.ClassName
isActive = H.ClassName "is-active"

isBoxed ∷ H.ClassName
isBoxed = H.ClassName "is-boxed"

isCentered ∷ H.ClassName
isCentered = H.ClassName "is-centered"

isDesktop ∷ H.ClassName
isDesktop = H.ClassName "is-desktop"

isColMin15 ∷ H.ClassName
isColMin15 = H.ClassName"is-col-min-15"

isDanger ∷ H.ClassName
isDanger = H.ClassName "is-danger"

isFullHeight ∷ H.ClassName
isFullHeight = H.ClassName "is-fullheight"

isGrouped ∷ H.ClassName
isGrouped = H.ClassName "is-grouped"

isGroupedMultiline ∷ H.ClassName
isGroupedMultiline = H.ClassName "is-grouped-multiline"

isHidden ∷ H.ClassName
isHidden = H.ClassName "is-hidden"

isHoverable ∷ H.ClassName
isHoverable = H.ClassName "is-hoverable"

isInfo ∷ H.ClassName
isInfo = H.ClassName "is-info"

isInlineBlock ∷ H.ClassName
isInlineBlock = H.ClassName "is-inline-block"

isInvisible ∷ H.ClassName
isInvisible = H.ClassName "is-invisible"

isJustifyContentLeft ∷ H.ClassName
isJustifyContentLeft = H.ClassName "is-justify-content-left"

isLarge ∷ H.ClassName
isLarge = H.ClassName "is-large"

isLight ∷ H.ClassName
isLight = H.ClassName "is-light"

isLink ∷ H.ClassName
isLink = H.ClassName "is-link"

isMedium ∷ H.ClassName
isMedium = H.ClassName "is-medium"

isMobile ∷ H.ClassName
isMobile = H.ClassName "is-mobile"

isOneThird ∷ H.ClassName
isOneThird = H.ClassName "is-one-third"

isPrimary ∷ H.ClassName
isPrimary = H.ClassName "is-primary"

isRight ∷ H.ClassName
isRight = H.ClassName "is-right"

isRounded ∷ H.ClassName
isRounded = H.ClassName "is-rounded"

isSelected ∷ H.ClassName
isSelected = H.ClassName "is-selected"

isSize2 ∷ H.ClassName
isSize2 = H.ClassName "is-size-2"

isSize3 ∷ H.ClassName
isSize3 = H.ClassName "is-size-3"

isSize5Desktop ∷ H.ClassName
isSize5Desktop = H.ClassName "is-size-5-desktop"

isToggle ∷ H.ClassName
isToggle = H.ClassName "is-toggle"

isTouch ∷ H.ClassName
isTouch = H.ClassName "is-touch"

level ∷ H.ClassName
level = H.ClassName "level"

levelItem ∷ H.ClassName
levelItem = H.ClassName "level-item"

levelLeft ∷ H.ClassName
levelLeft = H.ClassName "level-left"

m2 ∷ H.ClassName
m2 = H.ClassName "m-2"

mb0 ∷ H.ClassName
mb0 = H.ClassName "mb-0"

mb1 ∷ H.ClassName
mb1 = H.ClassName "mb-1"

mb2 ∷ H.ClassName
mb2 = H.ClassName "mb-2"

mb3 ∷ H.ClassName
mb3 = H.ClassName "mb-3"

media ∷ H.ClassName
media = H.ClassName "media"

mediaContent ∷ H.ClassName
mediaContent = H.ClassName "media-content"

mediaLeft ∷ H.ClassName
mediaLeft = H.ClassName "media-left"

message ∷ H.ClassName
message = H.ClassName "message"

messageBody ∷ H.ClassName
messageBody = H.ClassName "message-body"

messageHeader ∷ H.ClassName
messageHeader = H.ClassName "message-header"

ml1 ∷ H.ClassName
ml1 = H.ClassName "ml-1"

ml3 ∷ H.ClassName
ml3 = H.ClassName "ml-3"

ml5 ∷ H.ClassName
ml5 = H.ClassName "ml-5"

mr1 ∷ H.ClassName
mr1 = H.ClassName "mr-1"

mr3 ∷ H.ClassName
mr3 = H.ClassName "mr-3"



modal ∷ H.ClassName
modal = H.ClassName "modal"

modalBackground ∷ H.ClassName
modalBackground = H.ClassName "modal-background"

modalCard ∷ H.ClassName
modalCard = H.ClassName "modal-card"

modalCardHead ∷ H.ClassName
modalCardHead = H.ClassName "modal-card-head"

modalCardBody ∷ H.ClassName
modalCardBody = H.ClassName "modal-card-body"

modalCardFoot ∷ H.ClassName
modalCardFoot = H.ClassName "modal-card-foot"

modalCardTitle ∷ H.ClassName
modalCardTitle = H.ClassName "modal-card-title"

mt1 ∷ H.ClassName
mt1 = H.ClassName "mt-1"

mt2 ∷ H.ClassName
mt2 = H.ClassName "mt-2"

mt3 ∷ H.ClassName
mt3 = H.ClassName "mt-3"

navbar ∷ H.ClassName
navbar = H.ClassName "navbar"

navbarBrand ∷ H.ClassName
navbarBrand = H.ClassName "navbar-brand"

navbarBurger ∷ H.ClassName
navbarBurger = H.ClassName "navbar-burger"

navbarEnd ∷ H.ClassName
navbarEnd = H.ClassName "navbar-end"

navbarItem ∷ H.ClassName
navbarItem = H.ClassName "navbar-item"

navbarLink ∷ H.ClassName
navbarLink = H.ClassName "navbar-link"

navbarMenu ∷ H.ClassName
navbarMenu = H.ClassName "navbar-menu"

navbarDropdown ∷ H.ClassName
navbarDropdown = H.ClassName "navbar-dropdown"

notification ∷ H.ClassName
notification = H.ClassName "notification"

p2 ∷ H.ClassName
p2 = H.ClassName "p-2"

progress ∷ H.ClassName
progress = H.ClassName "progress"

section ∷ H.ClassName
section = H.ClassName "section"

subtitle ∷ H.ClassName
subtitle = H.ClassName "subtitle"

tabs ∷ H.ClassName
tabs = H.ClassName "tabs"

tag ∷ H.ClassName
tag = H.ClassName "tag"

tags ∷ H.ClassName
tags = H.ClassName "tags"

textarea ∷ H.ClassName
textarea = H.ClassName "textarea"

themeLight ∷ H.ClassName
themeLight = H.ClassName "theme-light"

title ∷ H.ClassName
title = H.ClassName "title"

